import { MorningOvertimeReadinessPromptViewState } from '../models/morning-overtime-readiness.model';

export const MORNING_OVERTIME_COMMENT_MAX_LENGTH = 200;
export const MORNING_OVERTIME_ROLE_HEAD = 'ROLE_HEAD';
export const MORNING_OVERTIME_TESTING_ROUTE = '/dashboard/testing';

export const MORNING_OVERTIME_ERROR_CODES = {
  alreadyAnswered: 'MORNING_OVERTIME_ALREADY_ANSWERED',
  afterCutoff: 'MORNING_OVERTIME_AFTER_CUTOFF',
  commentTooLong: 'MORNING_OVERTIME_COMMENT_TOO_LONG',
  invalidRequest: 'MORNING_OVERTIME_INVALID_REQUEST',
  groupDisabled: 'MORNING_OVERTIME_GROUP_DISABLED',
  dailyTestingRequired: 'MORNING_OVERTIME_DAILY_TESTING_REQUIRED',
  roleHead: 'MORNING_OVERTIME_ROLE_HEAD',
  roleNotEligible: 'MORNING_OVERTIME_ROLE_NOT_ELIGIBLE',
  noMainGroup: 'MORNING_OVERTIME_NO_MAIN_GROUP',
  userNotActive: 'MORNING_OVERTIME_USER_NOT_ACTIVE',
  groupPlanfixIdMissing: 'MORNING_OVERTIME_GROUP_PLANFIX_ID_MISSING',
  notGroupHead: 'MORNING_OVERTIME_NOT_GROUP_HEAD',
  groupNotManaged: 'MORNING_OVERTIME_GROUP_NOT_MANAGED',
  groupNotFound: 'MORNING_OVERTIME_GROUP_NOT_FOUND'
};

export const MORNING_OVERTIME_I18N_KEYS = {
  title: 'MORNING_OVERTIME_PROMPT_TITLE',
  commentLabel: 'MORNING_OVERTIME_COMMENT_LABEL',
  commentPlaceholder: 'MORNING_OVERTIME_COMMENT_PLACEHOLDER',
  commentCounter: 'MORNING_OVERTIME_COMMENT_COUNTER',
  readyYes: 'MORNING_OVERTIME_READY_YES',
  readyNo: 'MORNING_OVERTIME_READY_NO',
  submitting: 'MORNING_OVERTIME_SUBMITTING',
  submitSuccess: 'MORNING_OVERTIME_SUBMIT_SUCCESS',
  submitError: 'MORNING_OVERTIME_SUBMIT_ERROR',
  commentTooLong: 'MORNING_OVERTIME_COMMENT_TOO_LONG_UI',
  alreadyAnswered: 'MORNING_OVERTIME_ALREADY_ANSWERED_UI',
  afterCutoff: 'MORNING_OVERTIME_AFTER_CUTOFF_UI',
  groupDisabled: 'MORNING_OVERTIME_GROUP_DISABLED_UI',
  dailyTestingRequired: 'MORNING_OVERTIME_DAILY_TESTING_REQUIRED_UI',
  accessDenied: 'MORNING_OVERTIME_ACCESS_DENIED_UI',
  noMainGroup: 'MORNING_OVERTIME_NO_MAIN_GROUP_UI',
  userNotActive: 'MORNING_OVERTIME_USER_NOT_ACTIVE_UI',
  groupPlanfixIdMissing: 'MORNING_OVERTIME_GROUP_PLANFIX_ID_MISSING_UI',
  headActionLoading: 'MORNING_OVERTIME_HEAD_ACTION_LOADING',
  headActionEnable: 'MORNING_OVERTIME_HEAD_ACTION_ENABLE',
  headActionDisable: 'MORNING_OVERTIME_HEAD_ACTION_DISABLE',
  headActionSaving: 'MORNING_OVERTIME_HEAD_ACTION_SAVING',
  headSettingEnabled: 'MORNING_OVERTIME_HEAD_SETTING_ENABLED',
  headSettingDisabled: 'MORNING_OVERTIME_HEAD_SETTING_DISABLED',
  headActionError: 'MORNING_OVERTIME_HEAD_ACTION_ERROR',
  headSaveSuccess: 'MORNING_OVERTIME_HEAD_SAVE_SUCCESS',
  headSaveError: 'MORNING_OVERTIME_HEAD_SAVE_ERROR'
};

export const MORNING_OVERTIME_HIDDEN_PROMPT_STATE: MorningOvertimeReadinessPromptViewState = {
  isVisible: false,
  isLoading: false,
  isSubmitting: false,
  prompt: null,
  messageKey: '',
  commentErrorKey: ''
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/morning-overtime-readiness/constants/morning-overtime-readiness.constants.ts